import type { IconProps } from './IconsTypes'

export const VisaIcon = ({
  width = 43,
  height = 29,
  viewBox = '0 0 43 29',
  color = '#00579F',
}: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="42.2917" height="29" rx="3.52431" fill={color} />
    <path
      d="M18.0932 19.4336H15.7019L17.1976 10.1855H19.5887L18.0932 19.4336Z"
      fill="white"
    />
    <path
      d="M26.7625 10.4113C26.2908 10.2242 25.5427 10.0176 24.6177 10.0176C22.2563 10.0176 20.5934 11.2768 20.5832 13.0772C20.5635 14.4055 21.7738 15.1432 22.6789 15.5861C23.604 16.0387 23.9185 16.3341 23.9185 16.7375C23.9091 17.3571 23.171 17.6426 22.4825 17.6426C21.5278 17.6426 21.0162 17.4954 20.2389 17.1507L19.924 17.003L19.5894 19.0789C20.1502 19.3345 21.1835 19.5612 22.2563 19.5711C24.7654 19.5711 26.3989 18.3314 26.4182 16.4128C26.4278 15.36 25.7887 14.5534 24.411 13.8942C23.5746 13.471 23.0624 13.1857 23.0624 12.7528C23.0722 12.3592 23.4956 11.956 24.4398 11.956C25.2171 11.9363 25.7883 12.1231 26.221 12.3101L26.4373 12.4083L26.7625 10.4113Z"
      fill="white"
    />
    <path
      d="M29.9409 16.1574C30.1378 15.6261 30.8956 13.5698 30.8956 13.5698C30.8857 13.5896 31.0921 13.0287 31.2102 12.6844L31.3773 13.4813C31.3773 13.4813 31.8302 15.695 31.9285 16.1574C31.5548 16.1574 30.4132 16.1574 29.9409 16.1574ZM32.8926 10.1855H31.043C30.4726 10.1855 30.0392 10.3527 29.7931 10.9529L26.2412 19.4335H28.7503C28.7503 19.4335 29.1634 18.2921 29.2522 18.0462C29.5274 18.0462 31.9682 18.0462 32.3224 18.0462C32.391 18.3709 32.6077 19.4335 32.6077 19.4335H34.8218L32.8926 10.1855Z"
      fill="white"
    />
    <path
      d="M13.7044 10.1855L11.3625 16.4919L11.1066 15.2129C10.6737 13.7371 9.31582 12.1337 7.80054 11.3364L9.94558 19.4238H12.4743L16.2329 10.1855H13.7044Z"
      fill="white"
    />
    <path
      d="M9.18843 10.1855H5.34112L5.30176 10.3724C8.3029 11.1399 10.2905 12.9898 11.1071 15.2133L10.2708 10.9629C10.1331 10.3723 9.70992 10.205 9.18843 10.1855Z"
      fill="#FAA61A"
    />
  </svg>
)
